// src/redux/actions/cityActions.js
import {
    FETCH_GETSPECIALIZATION_REQUEST,
    FETCH_GETSPECIALIZATION_SUCCESS,
    FETCH_GETSPECIALIZATION_FAILURE,
    SET_SELECTED_GETSPECIALIZATION,
  } from '../types';
  import axios from '../../API/axios';
  
  export const fetchSpecialization = () => async (dispatch) => {
    dispatch({ type: FETCH_GETSPECIALIZATION_REQUEST });
  
    try {
      
      const response = await axios.get(`/MasterData/GetSpecializationsDDL`);
      let SpecializationList =response.data.responseData.map((val)=>{
        return{
          value:val.id,
          label:val.name,
        }
    })
      dispatch({
        type: FETCH_GETSPECIALIZATION_SUCCESS,
        payload: SpecializationList,
      });
    } catch (error) {
      dispatch({
        type: FETCH_GETSPECIALIZATION_FAILURE,
        payload: error.message,
      });
    }
  };
  
  export const selectSpecialization = (SpecializationId) => ({
    type: SET_SELECTED_GETSPECIALIZATION,
    payload: SpecializationId,
  });
  